import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  OrderHistory: [],
  FranchiseHistory: [],
};
//internally using immer lib (can create mutable state)
export const orderHistorySlice = createSlice({
  name: "orderHistoryData",
  initialState,
  reducers: {
    updateAllOrderHistory: (state, action) => {
      state.OrderHistory = action.payload;
    },
    getOrderHistory: (state, action) => {
      state.FranchiseHistory = action.payload;
    },
  },
});
// this is for dispatch
export const { updateAllOrderHistory, getOrderHistory } = orderHistorySlice.actions;
// this is for configureStore
export default orderHistorySlice.reducer;
